import { Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { getUserService } from 'portal/src/api/UsersService';
import useAuth from 'portal/src/auth/useAuth';
import UserForm from 'portal/src/components/systemAdministration/Form/User/UserForm';
import PageWithHeader from 'portal/src/layouts/base/PageWithHeader';

export default function UserSettingsPage() {
  const { id } = useAuth().getUser();

  const {
    data: user,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ['user', id],
    queryFn: () => getUserService(id),
    enabled: !!id,
  });

  return (
    <PageWithHeader title="Profile & Preferences">
      {isFetching || isError ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={12}
        >
          {isFetching && <CircularProgress />}
          {isError && <span>Failed to load user</span>}
        </Box>
      ) : (
        <UserForm entity={user || {}} isProfileView />
      )}
    </PageWithHeader>
  );
}
